import styled from 'styled-components';

export const SquareSection = styled.ul`
  margin: ${({ theme }) => theme.spacing.m};
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
  justify-content: center;
  list-style: none;
`;

export const TabsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const TitleTabContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  padding: 0 ${({ theme }) => theme.spacing.m};
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const GridWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.seasalt};
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const TitleContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.xm}`}
    ${({ theme }) => theme.spacing.m} ${({ theme }) => `${theme.spacing.m}`}
    ${({ theme }) => theme.spacing.m};
`;

export const TitleContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const Card = styled.div`
  border-bottom: 1px #f1f1f1 solid;
  padding-bottom: ${({ theme }) => theme.spacing.m};
  margin: ${({ theme }) => theme.spacing.m};
  margin-top: 0;
`;

export const TagSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Question = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const IconContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const Tag = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const ModalHeader = styled.div`
  text-align: center;
  margin: 16px 0;
`;

export const ModalContent = styled.div`
  text-align: justify;
  margin: 16px 0;
`;
